import scheduleView from '@/components/schedule/ScheduleView'

export default [
  {
    path: '/schedule',
    name: 'schedule',
    component: scheduleView,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/scheduleRoutes.js